import { Box, Container, Heading, HStack, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { Facebook, Mail } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const getCurrentYear = (): string => {
    const date = new Date();
    return date.getFullYear().toString();
  };

  return (
    <Box
      bg={{ base: 'gray.900', _dark: 'gray.950' }}
      color={{ base: 'gray.300', _dark: 'gray.400' }}
      py={{ base: '12', md: '16' }}
      borderTopWidth="1px"
      borderColor="border.muted"
    >
      <Container maxW="breakpoint-xl">
        <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: '10', md: '12' }}>
          {/* Company Section */}
          <VStack align={{ base: 'center', md: 'flex-start' }} gap="4">
            <Heading
              size="md"
              color="white"
              fontWeight="semibold"
              letterSpacing="tight"
              fontFamily="heading"
            >
              Palatium Fastigheter AB
            </Heading>
            <HStack gap="3" mt="2">
              <Link
                href="https://www.facebook.com/p/Palatium-Fastigheter-AB-100063816564762/"
                target="_blank"
                rel="noopener noreferrer"
                color="fg.subtle"
                _hover={{
                  transform: 'translateY(-2px)',
                  color: 'blue.400',
                }}
                transition="all 0.2s ease-in-out"
                aria-label="Facebook"
              >
                <Facebook size="22" />
              </Link>
            </HStack>
          </VStack>

          {/* Quick Links Section */}
          <VStack align={{ base: 'center', md: 'flex-start' }} gap="3">
            <Heading size="sm" color="white" fontWeight="semibold" mb="1" fontFamily="heading">
              Snabblänkar
            </Heading>
            <Link
              asChild
              fontSize="sm"
              color="fg.subtle"
              _hover={{
                color: 'white',
                textDecoration: 'underline',
              }}
              transition="color 0.2s ease-in-out"
            >
              <RouterLink to="/">Hem</RouterLink>
            </Link>
            <Link
              asChild
              fontSize="sm"
              color="fg.subtle"
              _hover={{
                color: 'white',
                textDecoration: 'underline',
              }}
              transition="color 0.2s ease-in-out"
            >
              <RouterLink to="/available-properties">Lediga bostäder</RouterLink>
            </Link>
            <Link
              asChild
              fontSize="sm"
              color="fg.subtle"
              _hover={{
                color: 'white',
                textDecoration: 'underline',
              }}
              transition="color 0.2s ease-in-out"
            >
              <RouterLink to="/rental-application">Intresseanmälan</RouterLink>
            </Link>
            <Link
              asChild
              fontSize="sm"
              color="fg.subtle"
              _hover={{
                color: 'white',
                textDecoration: 'underline',
              }}
              transition="color 0.2s ease-in-out"
            >
              <RouterLink to="/faq">För hyresgäster</RouterLink>
            </Link>
          </VStack>

          {/* Contact Section */}
          <VStack align={{ base: 'center', md: 'flex-start' }} gap="3">
            <Heading size="sm" color="white" fontWeight="semibold" mb="1" fontFamily="heading">
              Kontakta oss
            </Heading>
            <HStack gap="3" align="center">
              <Mail size="18" style={{ flexShrink: 0 }} />
              <Link
                href="mailto:info@palatium.se"
                fontSize="sm"
                color="fg.subtle"
                _hover={{
                  color: 'white',
                  textDecoration: 'underline',
                }}
                transition="color 0.2s ease-in-out"
              >
                info@palatium.se
              </Link>
            </HStack>
          </VStack>
        </SimpleGrid>

        {/* Copyright Section */}
        <Box borderTopWidth="1px" borderColor="border.muted" mt="12" pt="8">
          <Text textAlign="center" fontSize="sm" color="fg.subtle" fontFamily="body">
            © {getCurrentYear()} Palatium Fastigheter AB. Alla rättigheter förbehållna.
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
